import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FingerprintConfigurationEmployeeActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Hr/EmployeeF/EmployeeFBrowser")
	}

	render() {
		return (
			<Activity 
				name="FingerprintConfigurationEmployee"
				RenderedComponent={this.RenderedComponent}
				context="FingerprintConfigurationEmployee"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FingerprintConfigurationEmployeeActivity)
